var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stk-empty-box"},[_c('p',{staticClass:"stk-empty-box-title"},[(_vm.icon)?_c(_setup.Icon,{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")],1),_vm._v(" "),_c('div',{staticClass:"stk-empty-box-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }